// extracted by mini-css-extract-plugin
export default {"MarkdownViewerHelpText":"IssueMarkdownViewer-module__MarkdownViewerHelpText--oBt5c"};